import { alpha } from '@mui/system';
export var AccordionTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: function (_a) {
            var ownerState = _a.ownerState, theme = _a.theme;
            return ({
                boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.05)",
                border: "1px solid ".concat(theme.palette.divider),
                '&:not(:last-of-type)': {
                    borderBottom: 0,
                    boxShadow: "none",
                },
                '&:before': {
                    display: 'none',
                },
                '.MuiAccordionSummary-root': {
                    minHeight: 56,
                    paddingRight: theme.spacing(2.5),
                },
                '.MuiAccordionSummary-content': {
                    '&.Mui-expanded': {
                        margin: theme.spacing(1.5, 0),
                    }
                },
                '.MuiAccordionSummary-expandIconWrapper': {
                    width: 32,
                    height: 32,
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "100%",
                },
                '&:hover': {
                    backgroundColor: alpha(theme.palette.greySecondary[50], 0.24),
                    '.MuiAccordionSummary-expandIconWrapper': {
                        backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
                    },
                },
                '&.Mui-expanded': {
                    margin: 0,
                    '.MuiAccordionSummary-root': {
                        fontWeight: "bold",
                    },
                },
                '&.Mui-disabled': {
                    position: "relative",
                    backgroundColor: theme.palette.background.paper,
                    '.MuiAccordionSummary-root': {
                        opacity: 1,
                        '> *': {
                            opacity: 0.48,
                        },
                    },
                    '&:after': {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: alpha(theme.palette.greySecondary[50], 0.12),
                    },
                },
            });
        },
    },
}); };
export default AccordionTheme;
//# sourceMappingURL=theme.js.map